webpackJsonp([11346941736138],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/calipsy-club.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"html": "<div class=\"CalipsyContent\">\n    <div class=\"CalipsyContainer\">\n        <h2>What are the benefits of joining to the Calipsy Club?</h2>\n        <p>Each club member is informed about any contests, discounts or news in advance. Before we publish information on our fanpage, you will already know about it, and you will be able to benefit first from a discount, that can be limited in time and quantity!</p>\n        <p>The next thing we offer to those who, just like us, are fascinated by Merino Wool, is a special discount on all orders in our store!</p>\n        <p>The last bonus is a surprise that we are still working hard on. At the moment, we can say that it is an option you will not find anywhere else, and it will help you a lot to chose perfect color and material! Unfortunately, we can not reveal anything more, but we assure you that it's worth the wait!</p>\n        <h2 class=\"CalipsyContent-title\">How can I join?</h2>\n        <p>To join the Calipsy Club you literally  need 30sec! It's enough to give us your name or nickname and the email address that you want us to send you information to. The signing form is located at the very bottom of most pages, and also at the bottom of the current one.</p><p><strong>We would like to emphasize that we respect our customers, so we do not sell nor share the emails of our customers to third parties. We do not run advertising campaigns other than ours. Also, here at Calipsy, we hate spam – just like you. We promise to only email you with useful information.</strong></p>\n        <h2 class=\"CalipsyContent-title\">Can I resign?</h2>\n        <p>Of course, we do not keep anyone against their will. At any time you can let us know that you want us to remove all your contact information from our database. You do not even have to give any reason, although we will be happy to know what your comments are and how we can improve our services.</p>\n    </div>  \n</div>  \n        \n        \n        ",
				"frontmatter": {
					"title": "Calipsy Club",
					"newsletter": true,
					"banner": {
						"imageUrl": "/images/about/aboutBanner.jpg",
						"type": "small",
						"anchor": "center"
					}
				}
			}
		},
		"pathContext": {
			"path": "/calipsy-club"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---calipsy-club-ef1436b320675e505926.js